import { networkCollections } from "constants/collections";
export const getCollectionsByChain = (chain) => networkCollections[chain];
export const getCollectionChainAndName = (chain, name) =>
  networkCollections[chain].filter((d) => {
    return d.name === name;
  });
